import React, { useState, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import EastIcon from "@mui/icons-material/East";

function Navbar() {
  const [openDrawer, setOpenDrawer] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  // ✅ Listen to scroll and update navbar state
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleDrawerToggle = () => {
    setOpenDrawer(!openDrawer);
  };

  const navItems = ["Home", "About", "Programs", "Instructors", "Contact"];

  return (
    <>
      <AppBar
         height='0px' 
        position="fixed" 
        sx={{   background: isScrolled
            ? "rgba(0, 0, 0, 0.8)" // when scrolled
            : "rgba(255, 255, 255, 0.15)", 
          
            backdropFilter: 'blur(12px)', WebkitBackdropFilter: 'blur(12px)', boxShadow: 'none', color: '#fff', width:"95%", alignContent:"center", mx:{xs:1,md:3}, my:{xs:1.5,md:3}, borderRadius:"50px", zIndex: 10,}}
      >
        <Toolbar sx={{ justifyContent: "space-between" }}>
          {/* Mobile Menu Icon */}
          <Box sx={{ display: { xs: "flex", md: "none" }, alignItems: "center" }}>
            <IconButton
              edge="start"
              color="inherit"
              aria-label="menu"
              onClick={handleDrawerToggle}
            >
              <MenuIcon />
            </IconButton>
          </Box>

          {/* Logo */}
          <Typography
            variant="h6"
            sx={{
              flexGrow: { xs: 1, md: 0 },
              textAlign: { xs: "center", md: "left" },
              fontWeight: "bold",
              cursor: "pointer",
            }}
          >
            Zenova
          </Typography>

          {/* Nav Links (Desktop Only) */}
          <Box
            sx={{
              display: { xs: "none", md: "flex" },
              gap: 4,
              flexGrow: 1,
              justifyContent: "center",
            }}
          >
            {navItems.map((item) => (
              <Typography
                key={item}
                sx={{
                  cursor: "pointer",
                  fontWeight: 500,
                  "&:hover": { color: "#C29D59" },
                }}
              >
                {item}
              </Typography>
            ))}
          </Box>

          {/* Buttons */}
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Button
              variant="text"
              sx={{
                color: "#fff",
                textTransform: "none",
                mr: { xs: 0, md: 2 },
                display: { xs: "none", md: "inline-flex" },
              }}
            >
              Login
            </Button>

            <Button
              variant="contained"
              sx={{
                backgroundColor: "#fff",
                color: "#000",
                borderRadius: "50px",
                px: 1,
                py: 0.8,
                textTransform: "none",
                fontSize: { xs: "0.9rem", md: ".9rem" },
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 1.5,
                boxShadow: "0px 2px 6px rgba(0,0,0,0.1)",
                "&:hover": { backgroundColor: "#f5f5f5" },
              }}
            >
              <Typography sx={{ paddingLeft: 1, fontSize: "13px" }}>
                Sign Up
              </Typography>
              <Box
                sx={{
                  backgroundColor: "#000",
                  borderRadius: "50%",
                  width: { xs: 30, md: 26 },
                  height: { xs: 30, md: 25 },
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <EastIcon sx={{ color: "#fff", fontSize: "1.1rem" }} />
              </Box>
            </Button>
          </Box>
        </Toolbar>
      </AppBar>

      {/* Drawer for Mobile Menu */}
      <Drawer
        anchor="left"
        open={openDrawer}
        onClose={handleDrawerToggle}
        PaperProps={{
          sx: {
            backgroundColor: "#fff",
            color: "#000",
            width: 220,
          },
        }}
      >
        <List>
          {navItems.map((item) => (
            <ListItem button key={item} onClick={handleDrawerToggle}>
              <ListItemText primary={item} />
            </ListItem>
          ))}
        </List>
      </Drawer>

   
    </>
  );
}

export default Navbar;
